import { createContext, useContext } from 'react';

/**
 * Which top-level tab is currently active ("routines" | "quickstart" |
 * "exercises" | "history" | "shop"), set by App.js and read by Modal.jsx.
 *
 * [2026-08-18] The app moved from stacked, individually-collapsible panels
 * to a tab bar -- exactly one tab's content is visible at a time (the rest
 * stay mounted with display:none, not unmounted, so in-progress state like
 * an open "Add Routine" form survives switching away and back). That
 * display:none hiding is CSS-only and has no effect on a Modal, since
 * Modal.jsx renders via createPortal straight into document.body -- an
 * already-open Modal belonging to an inactive tab would otherwise keep
 * floating on top of whatever tab IS active. Modal reads this context and
 * auto-closes itself (calling its own onClose, same handler its close
 * button already uses) whenever its owning tab (passed as its `tabKey`
 * prop) stops being the active one.
 */
const TabContext = createContext(null);

export const TabProvider = TabContext.Provider;
export const useActiveTab = () => useContext(TabContext);

export default TabContext;
